import { Station } from '@app/core/types/stations';

export function isTranscriptionEnabled(station: Station) {
  return Boolean(station.featuresConfig?.transcription?.enabled);
}
